// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__8GkEq","topMenu":"Layout_topMenu__BshQm","activeProvider":"Layout_activeProvider__Ok11u","notActiveProvider":"Layout_notActiveProvider__oJwUP"};